<template>
    <li id="submit-el" v-if="progress === 0">
        <input type="submit" value="Request Transcription" class="btn-submit-red"/>
        <div class="error-message" v-if="errorMessage !== null">{{ errorMessage }}</div>
    </li>

    <li id="submit-el" v-else>
        <div class="progress">Progress:
            <span class="progress-pct">{{ progress.toFixed(1) }} %</span>
        </div>
        Uploading, please wait...
        <div class="progress-bar-outer">
            <div class="progress-bar-inner" v-bind:style="{width: progress + '%'}">
            </div>
        </div>
        <div class="error-message" v-if="errorMessage !== null">{{ errorMessage }}</div>
    </li>
</template>

<script>
export default {
    data: () => ({ progress: 0, errorMessage: null }),
}
</script>

<style scoped>
    .progress-bar-outer {
        width: 100%;
        position: relative;
        background: #eee;
        height: 4px;
        line-height: 4px;
    }

    .progress-bar-inner {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: #0083c8;
    }

    .progress {
        color: #aaa;
        font-size: 12px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/progress.vue